export default "__VITE_ASSET__DUGsIf1E__"